import { ref as d, computed as f } from "vue";
import { dom as v } from "./index339.js";
import { isFocusableElement as p, FocusableMode as w } from "./index340.js";
import { isMobile as E } from "./index344.js";
import { useDocumentEvent as r } from "./index548.js";
import { useWindowEvent as b } from "./index549.js";
function y(c, m, a = f(() => !0)) {
  function i(e, n) {
    if (!a.value || e.defaultPrevented) return;
    let t = n(e);
    if (t === null || !t.getRootNode().contains(t)) return;
    let s = (function u(o) {
      return typeof o == "function" ? u(o()) : Array.isArray(o) || o instanceof Set ? o : [o];
    })(c);
    for (let u of s) {
      if (u === null) continue;
      let o = u instanceof HTMLElement ? u : v(u);
      if (o != null && o.contains(t) || e.composed && e.composedPath().includes(o)) return;
    }
    return !p(t, w.Loose) && t.tabIndex !== -1 && e.preventDefault(), m(e, t);
  }
  let l = d(null);
  r("pointerdown", (e) => {
    var n, t;
    a.value && (l.value = ((t = (n = e.composedPath) == null ? void 0 : n.call(e)) == null ? void 0 : t[0]) || e.target);
  }, !0), r("mousedown", (e) => {
    var n, t;
    a.value && (l.value = ((t = (n = e.composedPath) == null ? void 0 : n.call(e)) == null ? void 0 : t[0]) || e.target);
  }, !0), r("click", (e) => {
    E() || l.value && (i(e, () => l.value), l.value = null);
  }, !0), r("touchend", (e) => i(e, () => e.target instanceof HTMLElement ? e.target : null), !0), b("blur", (e) => i(e, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
export {
  y as useOutsideClick
};
